<template>
  <div class="permissoes-perfil-page">

    <!-- ── SEÇÃO: Cabeçalho ── -->
    <div class="form-section">
      <div class="form-section__header">
        <div class="form-section__icon-wrap">
          <v-icon color="#0052A0" size="20">mdi-shield-key-outline</v-icon>
        </div>
        <div class="form-section__heading">
          <div class="form-section__title">Permissões do perfil{{ PerfilName ? `: ${PerfilName}` : "" }}</div>
          <div class="form-section__sub">Ative ou desative o que este perfil pode acessar</div>
        </div>
      </div>

      <div class="permissoes-toolbar">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="Buscar permissão..."
          dense outlined hide-details clearable color="#0052A0"
          class="permissoes-toolbar__busca"
        />
        <div class="permissoes-toolbar__acoes">
          <v-btn color="#0052A0" rounded elevation="0" @click="ativartudo" class="px-5">
            <v-icon left color="#FFD400" small>mdi-check-all</v-icon>
            <span style="color:#FFD400;font-weight:700;font-size:13px">Ativar todas</span>
          </v-btn>
          <v-btn outlined rounded elevation="0" color="#dc2626" @click="desativartudo" class="px-5">
            <v-icon left small>mdi-close-circle-outline</v-icon>
            <span style="font-size:13px">Desativar todas</span>
          </v-btn>
        </div>
      </div>
    </div>

    <!-- ── SEÇÃO: Tabela ── -->
    <div class="form-section form-section--last">
      <v-data-table
        :headers="headers"
        :items="list"
        item-key="id"
        :search="search"
        class="permissoes-table elevation-0"
        no-data-text="Sem dados"
        :no-results-text="`Sua busca por &quot;${search}&quot; não encontrou resultados.`"
        :footer-props="{
          'items-per-page-text': 'Registros por página: ',
          'page-text': '{0}-{1} de {2}',
        }"
      >
        <template v-slot:[`item.status`]="{ item }">
          <v-switch
            v-model="item.status"
            @click="changeStatus(item.id)"
            :loading="carregando"
            :value="item.status"
            :disabled="carregando"
            color="#0052A0"
            hide-details
            dense
            class="mt-0 pt-0 d-inline-flex"
          />
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import helper from "../../../mixins/helper";

export default {
  components: {},
  mixins: [helper],
  data: () => ({
    roleId: "",
    PerfilName: '',
    dialog: false,
    carregando: false,
    modal: {
      title: null,
      type: null,
    },
    hand: {
      id: null,
      name: null,
      label: null,
    },
    list: [],
    search: "",
    headers: [
      {
        text: "ID",
        value: "id",
        width: "12%",
        align: "start",
      },
      {
        text: "Nome",
        width: "25%",
        value: "name",
        align: "start",
      },
      {
        text: "Descrição",
        value: "label",
        align: "start",
      },
      {
        text: "Ativa",
        width: "9%",
        align: "center",
        value: "status",
        sortable: false,
        filterable: false,
      },
    ],
  }),
  mounted() {
    this.roleId = this.$route.params.id;
    this.PerfilName = this.$route.params.name;
    this.getPerfilPermission();
  },

  methods: {
    notificacao(title, msg, icon) {
      this.$swal({
        toast: true,
        position: "top-center",
        showConfirmButton: false,
        timer: 3000,
        icon: icon,
        title: title,
        text: msg,
      });
    },
    getPerfilPermission() {
      console.log('getPerfilPermission()')
      this.$http.get("perfilPermission/" + this.$route.params.id).then(
        (response) => {
          console.log(response)
          var i_list = [];
          //this.list = response.data;
          response.data.map((item)=>{
            if(item.status == "1"){
              item.status = true;
            }else{
              item.status = false
            }
            i_list.push(item)
          })
          this.list = i_list
        },
        (response) => {
          console.log(response);
        }
      );
    },
    changeStatus(permissionId) {
      this.carregando = true;
      this.$http
        .get("changePermission/" + this.$route.params.id + "/" + permissionId)
        .then(
          (response) => {
            this.carregando = false;
            this.notificacao("", response.body.message, "success");
          },
          (response) => {
            this.carregando = false;
            this.getPerfilPermission();
            this.notificacao("", response.body.message, "success");
          }
        );
    },
    async ativartudo() {

      //return alert(this.$route.params.id);
      await this.$http.get("activeAllPermissions/" + this.$route.params.id).then(
        (response) => {
          this.carregando = false;

          this.notificacao("", response.body.message, "success");
          this.getPerfilPermission();
        },
        (response) => {
          this.carregando = false;
          this.getPerfilPermission();
          this.notificacao("", response.body.message, "success");
        }
      );

    },
    desativartudo() {
      this.$http.get("desactiveAllPermissions/" + this.$route.params.id).then(
        (response) => {
          this.carregando = false;
          this.getPerfilPermission();
          this.notificacao("", response.body.message, "success");
        },
        (response) => {
          this.carregando = false;
          this.getPerfilPermission();
          this.notificacao("", response.body.message, "success");
        }
      );
    },
  },
};
</script>

<style scoped>
.permissoes-perfil-page {
  background: #fff;
  min-height: calc(100vh - 64px);
  padding: 28px 32px;
  width: 100%;
  box-sizing: border-box;
}

.form-section {
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 32px;
  margin-bottom: 32px;
}
.form-section--last { border-bottom: none; padding-bottom: 0; margin-bottom: 0; }

.form-section__header { display: flex; align-items: center; gap: 12px; }
.form-section__heading { flex: 1 1 0; min-width: 0; }
.form-section__icon-wrap {
  width: 34px; height: 34px; background: #e8f0fe; border-radius: 8px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.form-section__title { font-family: 'Inter', sans-serif; font-size: 0.92rem; font-weight: 700; color: #1e293b; }
.form-section__sub   { font-family: 'Inter', sans-serif; font-size: 0.78rem; color: #94a3b8; margin-top: 1px; }

.permissoes-toolbar {
  display: flex; flex-wrap: wrap; align-items: center; gap: 12px;
  margin-top: 20px;
}
.permissoes-toolbar__busca { flex: 1 1 280px; max-width: 360px; }
.permissoes-toolbar__acoes { display: flex; flex-wrap: wrap; gap: 8px; margin-left: auto; }

.permissoes-table >>> th {
  font-family: 'Inter', sans-serif !important; font-size: 0.72rem !important;
  font-weight: 700 !important; color: #64748b !important;
  text-transform: uppercase; letter-spacing: 0.5px;
  background: #f8fafc !important; padding: 10px 12px !important; white-space: nowrap;
}
.permissoes-table >>> td {
  font-family: 'Inter', sans-serif !important; font-size: 0.85rem !important;
  color: #1e293b !important; font-weight: 400 !important;
  padding: 6px 12px !important; border-bottom: 1px solid #f1f5f9 !important;
}

@media (max-width: 768px) { .permissoes-perfil-page { padding: 16px; } }
@media (max-width: 600px) {
  .permissoes-toolbar__busca { max-width: none; flex-basis: 100%; }
  .permissoes-toolbar__acoes { margin-left: 0; width: 100%; }
  .permissoes-toolbar__acoes > .v-btn { flex: 1 1 0; min-width: 0 !important; }
}
</style>
